'use client';

import { io, Socket } from "socket.io-client";

// Функция для получения токена
const getAuthToken = () => {
    if (typeof window === 'undefined') return '';
    const token = localStorage.getItem('token');
    return token ? `Bearer ${token}` : '';
};

const socket: Socket = io(process.env.NEXT_PUBLIC_SOCKET_URL, {
    autoConnect: false, // Не подключаемся автоматически, ждем пока токен будет доступен
    reconnectionDelayMax: 10000,
    transports: ['websocket'],
    secure: true,
    auth: (cb) => {
        // Динамически получаем токен при каждом подключении
        cb({
            'customerauthentication-token': getAuthToken(),
            'app': 'ledger' // Указываем, что это crypto wallet app (ledger)
        });
    },
    query: {
        'app': 'ledger' // Также передаем через query параметр для надежности
    },
    extraHeaders: {
        'ngrok-skip-browser-warning': 'true'
    }
});

export default socket;
